module.exports = __webpack_public_path__ + "img/blue_129.c60533d2.png";